// 📂 src/hooks/client/useClientProfileSwitch.ts
import useAlerts from "../useAlerts";
import useLoading from "../useLoading";
import useApiErrorHandler from "../useApiErrorHandler";
import ClientProfileSwitchService from "../../services/client/ClientProfileSwitchService.ts";

/**
 * 📌 Hook para cambiar o consultar el perfil activo del cliente.
 *
 * 👉 Maneja comunicación con el backend y feedback visual (alertas, loading, errores).
 */
export const useClientProfileSwitch = () => {
  const { show: showAlert } = useAlerts();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();
  const { handle } = useApiErrorHandler();

  /**
   * 🔄 Cambia el perfil activo del cliente.
   */
  const switchProfile = async (profileId: number) => {
    try {
      showLoadingIndicator();

      const response = await ClientProfileSwitchService.switchProfile(profileId);
      const { statusCode, type, title, message } = response;

      if (statusCode === 200) {
        showAlert(type, title, message);
      }
    } catch (error: any) {
      handle(error);
    } finally {
      hideLoadingIndicator();
    }
  };

  /**
   * 📥 Obtiene el perfil actualmente activo.
   */
  const getActiveProfile = async () => {
    try {
      showLoadingIndicator();

      const response = await ClientProfileSwitchService.getActiveProfile();
      // console.log(response);
      const { statusCode, data } = response;

      if (statusCode === 200 && data) {
        // console.log("Perfil activo actual:", data);
      }

      return data;
    } catch (error: any) {
      handle(error);
    } finally {
      hideLoadingIndicator();
    }
  };

  return { switchProfile, getActiveProfile };
};
